import bgLayer from '/assets/bahela/bg-layer.webp'
import backButton from '/assets/bahela/back-button-red.svg'
import panduan from '/assets/bahela/panduan.webp'
import tutorial from '/assets/bahela/tutorial.webp'
import bahela from '/assets/bahela/bahela.webp'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useCachedImage } from '@renderer/hooks/useCachedImage'
import { useCachedBackgroundImage } from '@renderer/hooks/useCachedBackgroundImage'

const TutorialPage: React.FC = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { projectId } = useParams()

  // Call all hooks at the top level
  const cachedBgLayer = useCachedBackgroundImage(bgLayer)
  const cachedBackButton = useCachedImage(backButton)
  const cachedTutorialImage = useCachedImage(i18n.language === 'id' ? panduan : tutorial)
  const cachedBahela = useCachedImage(bahela)

  return (
    <div
      className="background relative bg-hibiscus w-full h-full overflow-hidden"
      data-page="tutorial"
    >
      <div
        className="deco-img absolute top-0 left-0 w-full h-full bg-cover z-[0]"
        style={{ backgroundImage: `url(${cachedBgLayer})` }}
      />
      <div className="absolute z-[5] left-[50px] top-[102px] flex flex-col items-center">
        <button
          className=""
          onClick={() => navigate(`/${projectId}`)}
          aria-label={t('common.back')}
        >
          <img
            src={cachedBackButton}
            className="w-[106px] h-[106px] btn-shadow"
            alt={t('common.back')}
          />
        </button>
        <span className="font-body-bahela text-[32px] text-white">{t('common.back')}</span>
      </div>
      <div className="absolute top-[85px] w-full z-[1] text-center flex flex-col gap-[61px] items-center">
        <h1 className="font-serif-bahela text-[100px] text-center text-white">
          {t('bahela.tutorial.title')}
        </h1>
        <img
          src={cachedTutorialImage}
          className="w-[1801px] h-[771px]"
          alt={t('bahela.tutorial.title')}
        />
      </div>
      <img
        src={cachedBahela}
        alt="Bahela"
        className="z-[3] object-contain w-32 h-32 absolute top-20 right-20"
      />
    </div>
  )
}

export default TutorialPage
